import { useRouter } from 'next/router';
import { gql } from '@soundxyz/gql-string';
import { useAuth } from '@context/auth/base';
import { AuthArtistApplicationDocument, useQuery } from '@graphql/reactQuery';
import { CLIENT_QUERY_REDUCTION_ON_FRESH_SSR_STRATEGY, NAV_LINKS } from '@utils/constants';

/*#__PURE__*/ gql(/* GraphQL */ `
  query AuthArtistApplication {
    artistApplication {
      id
      status
    }
  }
`);

export function useAuthArtistApplicationStatus() {
  const { authUser } = useAuth();

  const { pathname } = useRouter();

  const isApplicationPage = pathname === NAV_LINKS.ArtistApplication;
  const {
    data,
    isLoading: loading,
    error,
  } = useQuery(AuthArtistApplicationDocument, {
    enabled: !!authUser?.id,
    filterQueryKey: {
      id: authUser?.id,
    },
    /**
     * when a user is applying we dont want to refetch here on window focus and
     * reroute them to the landing since we have a modal popped
     */
    refetchOnWindowFocus: !isApplicationPage,
    ...CLIENT_QUERY_REDUCTION_ON_FRESH_SSR_STRATEGY,
  });

  return {
    hasApplied: !!data?.data.artistApplication?.id,
    status: data?.data.artistApplication?.status || null,
    loading,
    error,
  };
}
